// This is the root of our app
// Will contain the app client and auth provider and link to router

import React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import ls from 'local-storage';

//import { getClient } from '@squirrellearningltd/go-shared-utils';
import { getClient } from '../../services/utils/client';
import { ErrorPage, Ssl } from '@squirrellearningltd/go-shared-components';

import { AuthProvider } from '../../services/user/AuthProvider';
import AppRouter from './components/AppRouter';

import { APP_NAME } from '../../services/constants';

const hostname = window && window.location && window.location.hostname;

Bugsnag.start({
    apiKey: '112ef5bd7b0c7c164caf36e3c5198c23',
    plugins: [new BugsnagPluginReact()],
    metadata: {
        app: 'Pupil GoWrite',
        releaseName: hostname === 'localhost' ? 'development' : !hostname.includes('staging') ? 'production' : 'staging'
    },
    enabledReleaseStages: [ 'production', 'staging' ],
    onError: (event) => {
        const user = JSON.parse(ls('go_pupil_user'));
        if (user && user.id && user.name) {
            event.setUser(user.id, '', `${user.name}`);
        } else {
            event.setUser('unknown', 'unknown', 'unknown');
        }
    }
});

const ErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React);

const Home = () => {
    return (
        <ErrorBoundary FallbackComponent={ErrorPage}>
            <ApolloProvider client={getClient(APP_NAME)} >
                <Ssl />
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </ApolloProvider>  
        </ErrorBoundary>
    )
}

export default Home;
